
import React from 'react'
import ContentLoader from "react-content-loader"
import { memo } from 'react'

const ProductSideBarSkeleton = () => {
    return (
        <div className="booking-place-wrapper">
            <div className="booking-place" id="scroll">
                <figure>
                    <div className="booking-image">
                        <ContentLoader className="form checkout-productdetail-skeleton"
                            height={'100%'}
                            width={'100%'}
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                        >
                            <rect x="0.5%" y="0%" rx="0" ry="0" width="100%" height={'100%'} />
                        </ContentLoader>
                    </div>
                </figure>
                <figcaption>
                    <div class="booked-place">
                        <ContentLoader className="form checkout-productdetail-title-skeleton"
                            height={'100%'}
                            width={'100%'}
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                        >
                            <rect x="5%" y="35%" rx="0" ry="0" width="90%" height={'10%'} />
                            <rect x="5%" y="55%" rx="0" ry="0" width="90%" height={'10%'} />

                            <rect x="5%" y="80%" rx="0" ry="0" width="40%" height={'30%'} />
                            <rect x="55%" y="80%" rx="0" ry="0" width="40%" height={'30%'} />


                        </ContentLoader>
                    </div>

                </figcaption>
            </div>


        </div>
    )
}

export default memo(ProductSideBarSkeleton)